/**
 * HRAnnouncementStatusService
 * Read-only — the three lifecycle rows are seeded constants.
 * Route: api/hrannouncementstatuses
 */
import { CrudService } from '../base/CrudService';
export class HRAnnouncementStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? HRAnnouncementStatusService.DEFAULT_SERVICE_PATH,
            basePath: HRAnnouncementStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
HRAnnouncementStatusService.DEFAULT_SERVICE_PATH = 'hr';
HRAnnouncementStatusService.BASE_PATH = 'api/hrannouncementstatuses';
//# sourceMappingURL=HRAnnouncementStatusService.js.map